import request from '../../utils/requests'
/** * Tag: CSTeacherAttend */
const baseUrl ="/api/CSTeacherAttend";

/** * 老师需要补签的数据分页查询 * @param {*} body * { *    CourseId Desc:课程ID Required:false *    CourseName Desc:课程名称 Required:false *    CourseClassId Desc:班级ID Required:false *    ClassName Desc:班级名称 Required:false *    OrgUserId Desc:老师ID Required:false *    UserNameOrPhone Desc:老师名称或手机号 Required:false *    StartTime Desc:开始时间 Required:false *    EndTime Desc:结束时间 Required:false *    BranchId Desc:校区ID Required:false *    OrgId Desc:机构ID Required:false *    Start Desc:开始行数 从0开始 Required:false *    Length Desc:页面大小 Required:false *    End Desc:结束行数 Required:false * } */async function _pagingForNeedSupplementSignT(body) {  return request(baseUrl+'/pagingForNeedSupplementSignT',{    method: 'POST',    body: body,  });
}

/** * 新增老师记上课（补签） * @param {*} body * { *    ClassTimeTableOrgUserRelationId Desc:关系ID Required:true *    BranchId Desc:校区 Required:true *    OrgId Desc:后台使用 Required:false * } */async function _add(body) {  return request(baseUrl+'/add',{    method: 'POST',    body: body,  });
}

export default{  _pagingForNeedSupplementSignT,  _add}



// WEBPACK FOOTER //
// ./src/services/cSTeacherAttend.js